function insertHeading() {
  const containers = document.querySelectorAll('.yn-rt-grid');

  if (containers.length) {
    containers.forEach(container => {
      // Prevent duplicate insertion
      if (!container.previousElementSibling || container.previousElementSibling.id !== 'exchange-returns-heading') {
        const heading = document.createElement('h1');
        heading.id = 'exchange-returns-heading';
        heading.textContent = 'Returns & Exchange';
        heading.style.fontWeight = '600';
        heading.style.color = '#000000';
        heading.style.textAlign = 'center';
        heading.style.marginTop = '16px';
        heading.style.marginBottom = '16px';
        heading.style.position = "relative";
        heading.style.top = '60px';
        heading.style.fontSize = "32px";
        container.parentNode.insertBefore(heading, container);
      }
    });

    // Convert h3 headings to h1
    const h3Elements = document.querySelectorAll('h3.yn-rt-font-bold.yn-rt-text-2xl.yn-rt-text-center');
    h3Elements.forEach(h3 => {
      const h1 = document.createElement('h1');
      h1.innerHTML = h3.innerHTML;
      h1.className = h3.className;
      h3.parentNode.replaceChild(h1, h3);
    });
  } else {
    setTimeout(insertHeading, 100);
  }
}

// Start the polling after DOM content is loaded
document.addEventListener('DOMContentLoaded', insertHeading);
